import OrganizationRoutesContainer from './OrganizationRoutesContainer';

export default OrganizationRoutesContainer;
